<p-confirmpopup></p-confirmpopup>
<p-card styleClass="customer-filter-card">
  <h2>Filter</h2>

  <div class="list-filter-grid">
    <div>
      <label for="location-filter">Ausgabeort</label>
      <p-multiSelect inputId="location-filter" class="w-100" [options]="locationService.locations"
                     [(ngModel)]="selectedLocations" optionLabel="city" optionValue="id" appendTo="body"
                     placeholder="Alle Ausgabeorte" [filter]="false" [showClear]="true"
                     (ngModelChange)="scheduleFilter()"
                     selectedItemsLabel="{0} ausgewählt"></p-multiSelect>
    </div>
    <div>
      <label for="weekday-filter">Wochentage</label>
      <p-multiSelect inputId="weekday-filter" class="w-100" [options]="weekdayService.weekdays"
                     [(ngModel)]="selectedWeekdays" optionLabel="title" optionValue="id" appendTo="body"
                     placeholder="Alle Wochentage" [filter]="false" [showClear]="true"
                     (ngModelChange)="scheduleFilter()"
                     selectedItemsLabel="{0} ausgewählt"></p-multiSelect>
    </div>
    <div>
      <label for="characteristic-filter">Eigenschaften</label>
      <p-multiSelect inputId="characteristic-filter" class="w-100" [options]="characteristicService.characteristics"
                     [(ngModel)]="selectedCharacteristics" optionLabel="title" optionValue="id" appendTo="body"
                     placeholder="Alle Eigenschaften" [filter]="false" [showClear]="true"
                     (ngModelChange)="scheduleFilter()"
                     selectedItemsLabel="{0} ausgewählt"></p-multiSelect>
    </div>
  </div>

  <section class="filter-group">
    <h3>Allgemein</h3>
    <div class="filter-grid">
      <div class="range-grid">
        <div class="range-filter">
          <div class="field-checkbox compact-checkbox">
            <p-checkbox [binary]="true" [(ngModel)]="activateDate" inputId="activate-date"
                        (ngModelChange)="scheduleFilter()"></p-checkbox>
            <label for="activate-date">Familienmitglied</label>
          </div>
          <div class="range-inputs">
            <p-floatlabel>
              <p-date-picker inputId="born_after" class="w-100" dateFormat="dd.mm.yy" [disabled]="!activateDate"
                             [(ngModel)]="bornAfter" appendTo="body"
                             (ngModelChange)="scheduleFilter()"></p-date-picker>
              <label for="born_after">Geboren von</label>
            </p-floatlabel>
            <p-floatlabel>
              <p-date-picker inputId="born_before" class="w-100" dateFormat="dd.mm.yy" [disabled]="!activateDate"
                             [(ngModel)]="bornBefore" appendTo="body"
                             (ngModelChange)="scheduleFilter()"></p-date-picker>
              <label for="born_before">Geboren bis</label>
            </p-floatlabel>
          </div>
        </div>

        <div class="range-filter">
          <div class="field-checkbox compact-checkbox">
            <p-checkbox [binary]="true" [(ngModel)]="activateOwnerDate" inputId="activate-owner-date"
                        (ngModelChange)="scheduleFilter()"></p-checkbox>
            <label for="activate-owner-date">Antragsteller</label>
          </div>
          <div class="range-inputs">
            <p-floatlabel>
              <p-date-picker inputId="owner_born_after" class="w-100" dateFormat="dd.mm.yy"
                             [disabled]="!activateOwnerDate" [(ngModel)]="ownerBornAfter" appendTo="body"
                             (ngModelChange)="scheduleFilter()"></p-date-picker>
              <label for="owner_born_after">Geboren von</label>
            </p-floatlabel>
            <p-floatlabel>
              <p-date-picker inputId="owner_born_before" class="w-100" dateFormat="dd.mm.yy"
                             [disabled]="!activateOwnerDate" [(ngModel)]="ownerBornBefore"
                             appendTo="body" (ngModelChange)="scheduleFilter()"></p-date-picker>
              <label for="owner_born_before">Geboren bis</label>
            </p-floatlabel>
          </div>
        </div>
      </div>

      <div class="quick-filter-grid">
        <div class="field-checkbox compact-checkbox">
          <p-checkbox [binary]="true" [(ngModel)]="singleParent" inputId="singleParent"
                      (ngModelChange)="scheduleFilter()"></p-checkbox>
          <label for="singleParent">Alleinerziehend</label>
        </div>
        <div class="field-checkbox compact-checkbox">
          <p-checkbox [binary]="true" [(ngModel)]="statusChange" inputId="status_change"
                      (ngModelChange)="scheduleFilter()"></p-checkbox>
          <label for="status_change">Geplante Statusänderung</label>
        </div>
        <div class="field-checkbox compact-checkbox">
          <p-checkbox [binary]="true" [(ngModel)]="missingFutureLocation" inputId="missing_future_location"
                      (ngModelChange)="scheduleFilter()"></p-checkbox>
          <label for="missing_future_location">Kein künftiger Ausgabeort</label>
        </div>
        <div class="household-filter">
          <div class="field-checkbox compact-checkbox">
            <p-checkbox [binary]="true" [(ngModel)]="householdFilter" inputId="household-filter"
                        (ngModelChange)="scheduleFilter()"></p-checkbox>
            <label for="household-filter">Haushalt</label>
          </div>
          <p-select inputId="minHousehold" [options]="householdOptions"
                    [(ngModel)]="minHousehold" [disabled]="!householdFilter" [showClear]="true" placeholder="Min."
                    (ngModelChange)="scheduleFilter()"/>
          <p-select inputId="maxHousehold" [options]="householdOptions"
                    [(ngModel)]="maxHousehold" [disabled]="!householdFilter" [showClear]="true" placeholder="Max."
                    (ngModelChange)="scheduleFilter()"/>
        </div>
      </div>
    </div>
  </section>
</p-card>
<div class="mt-3">
  <p-card class="w-100">
    <p-table [value]="customers()" [lazy]="true" (onLazyLoad)="loadCustomers($event)" [paginator]="true" [rows]="25"
             [totalRecords]="totalCustomers()" [showCurrentPageReport]="true" [loading]="loading()" dataKey="id"
             [rowsPerPageOptions]="[10, 25, 50, 100]"
             [filterDelay]="300"
             currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Nutzern">
      <ng-template pTemplate="header">
        <tr>
          <th>Nr.</th>
          <th pSortableColumn="first_name">Vorname
            <p-sortIcon field="first_name"></p-sortIcon>
          </th>
          <th pSortableColumn="last_name">Nachname
            <p-sortIcon field="last_name"></p-sortIcon>
          </th>
          <th pSortableColumn="street">Adresse
            <p-sortIcon field="street"></p-sortIcon>
          </th>
          <th pSortableColumn="status">Status
            <p-sortIcon field="status"></p-sortIcon>
          </th>
          <th>Haushalt</th>
          @if (canEditCustomers) {
            <th></th>
          }
        </tr>

        <tr>
          <th>
            <p-columnFilter type="text" field="code" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input pInputText class="w-100" type="text" [value]="value ?? ''"
                       (input)="filter($any($event.target).value)">
              </ng-template>
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter type="text" field="first_name" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input pInputText class="w-100" type="text" [value]="value ?? ''"
                       (input)="filter($any($event.target).value)">
              </ng-template>
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter type="text" field="last_name" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input pInputText class="w-100" type="text" [value]="value ?? ''"
                       (input)="filter($any($event.target).value)">
              </ng-template>
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter type="text" field="address" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <input pInputText class="w-100" type="text" [value]="value ?? ''"
                       (input)="filter($any($event.target).value)">
              </ng-template>
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter field="status" matchMode="in" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-multiSelect appendTo="body" [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)"
                               [filter]="false" optionLabel="title" placeholder="Alle">
                  <ng-template let-option pTemplate="item">
                    <span class='status-badge status-{{option.status}}'>{{ option.title }}</span>
                  </ng-template>
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th></th>
          @if (canEditCustomers) {
            <th style="min-width: 140px"></th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-customer>
        <tr>
          <td>
            @if (customer.code) {
              <span>{{ customer.code.location.abbreviation }} {{ customer.code.value }}</span>
            }
            @if (customer.code_rotation_1) {
              <span>{{ customer.code_rotation_1.location.abbreviation }}
                {{ customer.code_rotation_1.value }}-1</span>
            }
            @if (customer.code_rotation_2) {
              <span>{{ customer.code_rotation_2.location.abbreviation }}
                {{ customer.code_rotation_2.value }}-2</span>
            }
          </td>
          <td>{{ customer.first_name }}</td>
          <td>{{ customer.last_name }}</td>
          <td>
            <span>{{ customer.street }} {{ customer.house_number }}</span><br>
            @if (customer.address_addition) {
              <span>{{ customer.address_addition }}</span><br>
            }
            {{ customer.zip }} {{ customer.city }}
          </td>
          <td>@if (customer.status) {
            <span class="status-badge status-{{customer.status}}">{{ getStatusLabel(customer.status) }}</span>
          }
          </td>
          <td>{{ customer.family_members | household | async }}</td>
          @if (canEditCustomers) {
            <td>
              <p-button [routerLink]="['edit', customer.id]" icon="pi pi-pencil"
                        [rounded]="true" [outlined]="true"></p-button>
              @if (authService.user()?.role?.id === RoleEnum.Admin) {
                <p-button icon="pi pi-trash" [rounded]="true" [outlined]="true" severity="danger"
                          class="ms-2" (click)="deleteCustomer(customer.id, $event)"></p-button>
              }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">Keine Nutzer gefunden</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="table-actions">
      <p-button [disabled]="memberXlsxLoading()" link class="text-primary" (click)="exportMemberXLSX()">
        @if (memberXlsxLoading()) {
          <i class="pi pi-spinner"></i>
        } @else {
          <i class="pi pi-download"></i>
        }
        Familienmitglieder-Export
      </p-button>
      <p-button [disabled]="xlsxLoading()" link class="text-primary" (click)="exportXLSX()">
        @if (xlsxLoading()) {
          <i class="pi pi-spinner"></i>
        } @else {
          <i class="pi pi-download"></i>
        }
        Nutzer-Export
      </p-button>
    </div>
  </p-card>
</div>
